<template>
  <div class="single">
    <div class="post-content" v-html="the_content"></div>
    <div v-if="is_left || is_right" class="navigation">
      <a v-if="is_left" v-on:click="move(false, $event)" href="#" title="możesz przewijać używając klawisza strzałki w lewo" id="in_page_previous" class="navigate-back">
        <i class="fas fa-chevron-left"></i>
      </a>&nbsp;&nbsp;
      <a v-if="is_right" v-on:click="move(true, $event)" href="#" title="możesz przewijać używając klawisza strzałki w prawo" id="in_page_next" class="navigate-forward">
        <i class="fas fa-chevron-right"></i>
      </a>
    </div>
  </div>
</template>

<script>

import {inPageNavigation} from "../../plugins/in_page_navigation.js";

export default {
  name: "fcwpDefaultContent",
  props: ["item_id", "content"],

  data() {
    return {
      navigation: null,
      the_content: null,
      is_left: false,
      is_right: false,
    };

  },

  async mounted() {
    this.navigation = new inPageNavigation(this);
    this.navigation.setContent(this.content, this.item_id);
    // this.the_content = this.navigation.data;
  },
  watch: {
    content: async function () {
      this.navigation.setContent(this.content, this.item_id);
    }
  },
  methods: {
    move: function(isForward, e) {
      e.preventDefault();
      e.stopPropagation();
      this.navigation.move(isForward);
    }
  }

};
</script>

<style lang="scss">
.single {
  margin-top: 1vw;
  font-size: 20pt;
  .frm_style_formidable-style.with_frm_style {
        font-size: initial !important ;
      }
  strong,
  b {
    font-family: "Oswald", sans-serif;
    font-size: 85%;
    font-weight: 400;
  }
  li {
    margin-bottom: 0.7rem;
  }
  img {
    max-width: 100%;
    height: auto;
  }
}
h1.post-title {
  color: rgb($quinary-color);
}

.post-content {
  font-family: "Palatino-Linotype", serif;
  text-align: left;
  margin: 2vw 0;
  a {
    text-decoration: underline;
  }
  a:hover {
    text-decoration: underline rgb($secondary-color);
  }
}




</style>
